import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mobile: true,
    utm: {
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
      utm_term: '',
      utm_content: '',
    },
    scroll: {
      offset: 0,
      sections: ['#about', '#topics', '#review'],
      position: '',
    },
  },
  mutations: {
    setMobile(state, mobile) {
      state.mobile = mobile
    },
    saveUtm(state, query) {
      state.utm.utm_source = query.utm_source ? query.utm_source : ''
      state.utm.utm_medium = query.utm_medium ? query.utm_medium : ''
      state.utm.utm_campaign = query.utm_campaign ? query.utm_campaign : ''
      state.utm.utm_term = query.utm_term ? query.utm_term : ''
      state.utm.utm_content = query.utm_content ? query.utm_content : ''
    },
    setScrollOffset(state, offset) {
      state.scroll.offset = offset
    },
    setScrollPosition(state, position) {
      state.scroll.position = position
    },
  },
  actions: {

  }
})
